// Careers content layer — edit these JSON files to change page copy, dropdown
// options, schools/departments, posts, degrees, file rules, etc. The careers
// pages iterate over this data, so no component changes are needed for content.
import content from "./content.json";
import teaching from "./teaching.json";
import nonTeaching from "./nonTeaching.json";
import geo from "./indiaGeo.json"; // { states:[], districts:{state:[]}, cities:{state:[]} }

const careersData = { content, teaching, nonTeaching, geo };

export { content, teaching, nonTeaching, geo };
export default careersData;
